// extracted by mini-css-extract-plugin
export default {"root":"DjYHz","desktop":"unBCK","tablet":"M8n7n","smallMobile":"I6NOf","mobile":"WSlIr","aspectRatioContainer":"A_gpy","banner":"yrQ8q","content":"wqXMo","action":"T7S1W"};